import { z } from 'zod';

/**
 * Data shape for pure Markdown content rendering.
 * Displays formatted markdown text in dashboard components.
 *
 * Used by both dashboard MarkdownComponent and chat blocks.
 */
export const MarkdownDataSchema = z.object({
  content: z.string().describe('Markdown formatted text content to display'),
});

export type MarkdownData = z.infer<typeof MarkdownDataSchema>;

/**
 * Unified markdown component schema for LLM and dashboard use.
 *
 * Strict schema - all props must be explicitly defined.
 */
export const MarkdownSchema = z.object({
  type: z.literal('markdown').describe('Markdown component type'),
  content: z.string().describe('Markdown text content'),
});

/** @public Input type for MarkdownSchema - use for component props */
export type MarkdownSchemaInput = z.input<typeof MarkdownSchema>;

/** @public Output type for MarkdownSchema - use after Zod parsing */
export type MarkdownSchemaOutput = z.output<typeof MarkdownSchema>;
